import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RuntimeConfigurationService } from 'gain-web/shared-modules/runtime-configuration/runtime-configuration.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomHttpErrorInterceptor implements HttpInterceptor {
  private domainUrls: string[] = [];
  private isHttpRequestInterceptable: boolean = false;

  constructor(
    private _snackBar: MatSnackBar,
    private _config: RuntimeConfigurationService,
  ) {}

  intercept<T>(request: HttpRequest<T>, next: HttpHandler) {
    this.setupConfigurationSettings();

    if (
      this.isHttpRequestInterceptable &&
      this.isValidRequestToIntercept(request)
    ) {
      return next.handle(request).pipe(
        catchError((error) => {
          if (error.status !== 400) {
            const message = this.getErrorMessageBasedOnStatusCodes(
              error.status,
            );
            this._snackBar.open(message, 'Close');

            return throwError(() => error);
          }

          return next.handle(request);
        }),
      );
    }

    return next.handle(request);
  }

  setupConfigurationSettings(): void {
    if (this._config && this._config.isConfigInitialized()) {
      this.domainUrls = [];
      const { apiHostMode, apiUrl, localApiUrl, interceptHttpRequests } =
        this._config.get();
      if (apiHostMode === 'local' && localApiUrl) {
        this.domainUrls.push(localApiUrl);
      } else {
        this.domainUrls = [apiUrl];
      }
      this.isHttpRequestInterceptable = interceptHttpRequests;
    }
  }

  getErrorMessageBasedOnStatusCodes(statusCode: number): string {
    switch (statusCode) {
      case 0:
        return 'Unable to connect to server. Please contact administrator.';
      case 401:
        return 'Your session has expired. Please log in again.';
      case 403:
        return "You don't have permission to perform this action.";
      case 404:
        return 'Requested resource not found.';
      case 429:
        return 'You are making requests too quickly. Please wait and try again.';
      case 500:
        return 'A server error occurred. Please try again later.';
      case 503:
        return 'Service is temporarily unavailable. Try again shortly.';
      case 504:
        return 'The request timed out. Please try again.';
      default:
        return 'Error occurred';
    }
  }

  isValidRequestToIntercept<T>(request: HttpRequest<T>): boolean {
    const matchingRequest = this.domainUrls.filter((_) =>
      request.url.includes(_),
    );
    return (
      matchingRequest.length > 0 &&
      request.method !== 'OPTIONS' &&
      !request.url.includes('Logging')
    );
  }
}
